const getters = {
  isMyAccountViewActive(state) {
    return state.settings;
  },
  isSecurityPermitsViewActive(state) {
    return state.settings;
  },
};

export default getters;
